/**
 * localStorage 辅助工具
 * 支持过期时间功能，参照 cookie.js 实现
 */

const EXPIRE_PREFIX = '__expire__';

export function getLocal(key) {
  var raw = localStorage.getItem(key);
  if (raw === null) return undefined;
  // 检查是否有过期时间
  var expireTime = localStorage.getItem(EXPIRE_PREFIX + key);
  if (expireTime) {
    if (new Date().getTime() > parseInt(expireTime)) {
      // 已过期，清除
      localStorage.removeItem(key);
      localStorage.removeItem(EXPIRE_PREFIX + key);
      return undefined;
    }
  }
  return raw;
}

/**
 * 设置localStorage
 * @param {*} key
 * @param {*} val
 * @param {*} expires 过期时间 单位：天，不足一天用小数（与cookie.js一致）
 */
export function setLocal(key, val, expires) {
  localStorage.setItem(key, val);
  if (expires) {
    var expireTime = new Date().getTime() + expires * 24 * 60 * 60 * 1000;
    localStorage.setItem(EXPIRE_PREFIX + key, expireTime);
  } else {
    localStorage.removeItem(EXPIRE_PREFIX + key);
  }
}

export function removeLocal(key) {
  localStorage.removeItem(key);
  localStorage.removeItem(EXPIRE_PREFIX + key);
}

/**
 * Token 辅助类（localStorage 版本）
 * 与 cookie.js 中的 TokenUtil 保持一致的接口
 */
class LocalTokenUtil {
  constructor() {
    this.orgKey = 'apollo_org_' + process.env.API_ENV_TAG;
    this.tokenKey = 'apollo_student_' + process.env.API_ENV_TAG;
    this.studentKey = 'apollo_studentInfo_' + process.env.API_ENV_TAG;
    this.openidKey = 'apollo_openid_' + process.env.API_ENV_TAG;
    // 默认过期时间，与cookie.js一致
    this.defaultExpires = (1 / 24) * 6;
    // usePasswordLogin 标记key
    this.passwordLoginKey = 'apollo_usePasswordLogin_' + process.env.API_ENV_TAG;
  }
  get(orgid) {
    return getLocal(this.tokenKey + '_' + orgid);
  }
  set(token, orgid) {
    token = token + ' ' + process.env.API_ENV_TAG;
    return setLocal(this.tokenKey + '_' + orgid, token, this.defaultExpires);
  }
  remove(orgid) {
    return removeLocal(this.tokenKey + '_' + orgid);
  }
  getorg() {
    return getLocal(this.orgKey);
  }
  setorg(org) {
    return setLocal(this.orgKey, org, 7);
  }
  removeorg() {
    return removeLocal(this.orgKey);
  }
  getStudent(orgid) {
    return getLocal(this.studentKey + '_' + orgid);
  }
  setStudent(student, orgid) {
    return setLocal(this.studentKey + '_' + orgid, student, 7);
  }
  removeStudent(orgid) {
    return removeLocal(this.studentKey + '_' + orgid);
  }
  // 标记是否使用密码登录
  setUsePasswordLogin(flag) {
    return setLocal(this.passwordLoginKey, flag ? '1' : '0', 7);
  }
  getUsePasswordLogin() {
    return getLocal(this.passwordLoginKey) === '1';
  }
  removeUsePasswordLogin() {
    return removeLocal(this.passwordLoginKey);
  }
}

export const localTokenUtil = new LocalTokenUtil();



// WEBPACK FOOTER //
// ./src/utils/localStorageHelper.js